export default "__VITE_ASSET__gaIoAEMu__"